import { useNavigate } from 'react-router';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/common/components/ui/select';

import { PageOption } from '../types/navigation';

interface PageNavigationDropdownProps {
  currentPage: string;
  pages: PageOption[];
}

export const PageNavigationDropdown = ({
  currentPage,
  pages,
}: PageNavigationDropdownProps) => {
  const navigate = useNavigate();

  const handleValueChange = (value: string) => {
    const selectedPage = pages.find((page) => page.value === value);
    if (selectedPage) {
      navigate(selectedPage.route);
    }
  };

  return (
    <Select value={currentPage} onValueChange={handleValueChange}>
      <SelectTrigger className="bg-terre gap-4 cursor-pointer border-0 text-warm-gray-50 hover:bg-terre/90 [&_svg]:stroke-warm-gray-50 [&_svg]:opacity-100">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {pages.map((page) => (
          <SelectItem key={page.value} value={page.value}>
            {page.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
